import type { MisconceptionDefinition } from '../types'

/** REK — Schatten nieuwe specifieke misconcepties (slice 6). */
export const schattenRonde2Misconceptions: MisconceptionDefinition[] = [
  // ── REK-SCHATTEN: nieuwe specifieke misconcepties ────────────────────
  {
    id: 'rek.schatten-vergeet-optellen',
    label: 'Schat: vergeet tweede operand op te tellen',
    module: 'Basisrekenen',
    description:
      'Bij meerstaps-schattingen vergeet leerling de tweede dag/portie/operand mee op te tellen.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-nabijheid-boven-deelbaarheid',
    label: 'Schat: kiest dichtstbijzijnd getal boven deelbaar getal',
    module: 'Basisrekenen',
    description:
      'Bij een schat-deling kiest leerling het dichtstbijzijnde ronde getal als afronding, ook als een iets verder weg gelegen getal beter deelbaar is (bv. 500 i.p.v. 480 voor ÷ 6).',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-ronde-getal-altijd-handig',
    label: 'Schat: denkt dat ronde getallen altijd handig zijn',
    module: 'Basisrekenen',
    description:
      'Leerling neemt aan dat afronden op een rond getal altijd de handigste strategie is, ongeacht de operatie (negeert deelbaarheid bij delen).',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-strategie-onverschillig',
    label: 'Schat: ziet geen verschil tussen schattingsstrategieën',
    module: 'Basisrekenen',
    description:
      'Leerling ziet geen kwaliteitsverschil tussen verschillende schattingsstrategieën — kan niet beoordelen welke strategie voor déze opgave optimaal is.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-richting-onbewust',
    label: 'Schat: mixt over- en onderschatting onbewust',
    module: 'Basisrekenen',
    description:
      'In een budget-/voldoende-context mixt leerling over- en onderschatting zonder bewuste richting — schat één kant naar boven, andere naar beneden, zonder check tegen de vraag-richting (is het genoeg?).',
    typicalFamilies: ['REK-SCHATTEN'],
  },
  {
    id: 'rek.schatten-onderschatten-bij-budget',
    label: 'Schat: onderschatten bij "is het genoeg?"',
    module: 'Basisrekenen',
    description:
      'Bij een budget-vraag ("is dit genoeg?") onderschat leerling de kosten — eenzijdig naar beneden afronden bewijst niets over genoegzaamheid; je moet juist naar boven afronden om zeker te zijn.',
    typicalFamilies: ['REK-SCHATTEN'],
  },
]
